/* eslint-disable */

export default {
    0: {
        stockname: '名称/价格',
        targetprice: '平均目标价',
        total: '成交额/净买入',
        wch: '自选',
        etfname: '名称代码',
        high52: '52周最高价',
        fundname: '名称',
        increase: '近1年涨幅',
        fundscale: '基金规模',
        bondprice: '价格/年化收益率',
        date: '票息/到期日',
        title: '相关推荐',
        more: '更多',
        date1: '距到期',
        date2: '天',
        premium: '权利金',
        return1: '回报率',
        annualized1: '年化回报率',
        return2: '回报率',
        annualized2: '年化回报率',
        probability: '概率',
        optionname: '期权名称',
        volume: '成交量',
        price: '最新价',
        purchase: '起投金额',
        optiondlg: {
            buy: '买入',
            sell: '卖出',
            title: '合约明细',
            shareSize: '股',
            unit: '张',
            dedaline: '当期权到期时',
            part1title: '当期权到期时',
            part1Txt1: '若股票价格',
            part1Txt2: '，收获权利金',
            part1Txt3: '',
            part2Txt1: '若股票价格',
            part2Txt2: '，收获权利金',
            part2Txt3: '，需要以',
            part2Txt4: '卖出',
            part2Txt5: '股',
            part2Txt6: '买入',
            strikedIntervalReturn: '被行权回报率',
            strikedAnnualizedReturn: '被行权年化回报率',
            tip: '*以上所有数据与信息仅供参考，不构成投资建议',
            btn: '查看'
        },
        verify: '认证专业投资者查看产品详情>',
        tenor1: '期限(年)',
        tenor2: '期限(月)',
        tenor3: '期限(天)',
        coupon: '年化票息',
        coupon_shark: '票息',
        client_yield: '收益率',
        coupon_flat: '绝对票息',
        strike: '执行水平',
        put_strike: '行权价',
        participation_strike: '参与执行水平',
        participation: '参与率',
        ko_level: '敲出水平',
        wtchNum: '自选数量',
        piauth01: '完成专业投资者认证',
        piauth02: '查看升幅、募集额度',
        toauthBtn: '去认证',
        viewBtn: '查看更多',
    },
    // 繁体版
    1: {
        stockname: '名稱/價格',
        targetprice: '平均目標價',
        total: '成交額/淨買入',
        wch: '自選',
        etfname: '名稱代碼',
        high52: '52周最高價',
        fundname: '名稱',
        increase: '近1年漲幅',
        fundscale: '基金規模',
        bondprice: '價格/年化收益率',
        date: '票息/到期日',
        title: '相關投資產品',
        more: '更多',
        date1: '距到期',
        date2: '天',
        premium: '權利金',
        return1: '回報率',
        annualized1: '年化回報率',
        return2: '回報率',
        annualized2: '年化回報率',
        probability: '概率',
        optionname: '期權名稱',
        volume: '成交量',
        price: '最新價',
        purchase: '起投金額',
        optiondlg: {
            buy: '買入',
            sell: '賣出',
            title: '合約明細',
            shareSize: '股',
            unit: '張',
            dedaline: '當期權到期時',
            part1title: '當期權到期時',
            part1Txt1: '若股票價格',
            part1Txt2: '，收穫權利金',
            part1Txt3: '',
            part2Txt1: '若股票價格',
            part2Txt2: '，收穫權利金',
            part2Txt3: '，需要以',
            part2Txt4: '賣出',
            part2Txt5: '股',
            part2Txt6: '買入',
            strikedIntervalReturn: '被行權回報率',
            strikedAnnualizedReturn: '被行權年化回報率',
            tip: '*以上所有數據與信息僅供參考，不構成投資建議',
            btn: '查看'
        },
        verify: '認證專業投資者查看產品詳情>',
        tenor1: '期限(年)',
        tenor2: '期限(月)',
        tenor3: '期限(天)',
        coupon: '年化票息',
        coupon_shark: '票息',
        client_yield: '收益率',
        coupon_flat: '絕對票息',
        strike: '執行水平',
        put_strike: '行權價',
        participation_strike: '參與執行水平',
        participation: '參與率',
        ko_level: '敲出水平',
        wtchNum: '自選數量',
        piauth01: '完成專業投資者認證',
        piauth02: '查看升幅、募集額度',
        toauthBtn: '去認證',
        viewBtn: '查看更多',
    },
    // 英文版
    2: {
        stockname: 'Name/Price',
        targetprice: 'Target Price',
        total: 'Volume/Net Flow',
        wch: 'Watchlist',
        etfname: 'Name/Price',
        high52: '52wk High',
        fundname: 'Name',
        increase: '1Y Return',
        fundscale: 'Fund Size',
        bondprice: 'Price/YTM',
        date: 'Maturity',
        title: 'Related Investment Products',
        more: 'More',
        date1: '',
        date2: ' Days to Expiry',
        premium: 'Premium',
        return1: 'ROI',
        annualized1: 'Annualized',
        return2: 'Return Rate',
        annualized2: 'Annualized Return Rate',
        probability: 'Probability',
        optionname: 'Option Name',
        volume: 'Volume',
        price: 'Latest Price',
        purchase: 'Minimum Amount',
        optiondlg: {
            buy: 'Buy ',
            sell: 'Sell ',
            title: 'Contract Details',
            shareSize: ' shares of ',
            unit: ' ',
            dedaline: 'Upon option expiration:',
            part1title: 'Upon option expiration:',
            part1Txt1: 'If the stock price ',
            part1Txt2: ' , collect premium of',
            part1Txt3: '',
            part2Txt1: 'If the stock price ',
            part2Txt2: ', collect premium of ',
            part2Txt3: 'and need to ',
            part2Txt4: 'sell ',
            part2Txt5: 'shares of ',
            part2Txt6: 'buy ',
            part2Txt7: 'at ',
            strikedIntervalReturn: 'ROI If Assigned',
            strikedAnnualizedReturn: 'Annualized ROI If Assigned',
            tip: '*All the above data and information are for reference only and do not constitute investment advice.',
            btn: 'View'
        },
        verify: 'Verify as PI for details >',
        tenor1: 'Tenor(Y)',
        tenor2: 'Tenor(M)',
        tenor3: 'Tenor(D)',
        coupon: 'Coupon Rate',
        coupon_shark: 'Coupon',
        client_yield: 'Yield',
        coupon_flat: 'Coupon',
        strike: 'Strike',
        put_strike: 'Put Strike',
        participation_strike: 'Participation Strike',
        participation: 'Participation',
        ko_level: 'Ko Level',
        day: 'D',
        year: 'Y',
        month: 'M',
        wtchNum: 'Watch Count',
        piauth01: 'Complete PI Verification',
        piauth02: 'View Price Change and Fundraising Amount',
        toauthBtn: 'Verify Now',
        viewBtn: 'View more',
    },
    5: {
        stockname: '銘柄名/株価',
        targetprice: '平均目標株価',
        total: '売買代金/買越額',
        wch: '',
        etfname: '銘柄名/株価',
        high52: '52週高値',
        fundname: 'ファンド名',
        increase: '年間騰落率',
        fundscale: '純資産総額',

        bondprice: 'Price/YTM', // 债卷相关，JP 没有这个字段
        date: 'Maturity', // 债卷相关，JP 没有这个字段
        title: 'Related Investment Products', // 债卷相关，JP 没有这个字段
        more: 'もっと見る',

        date1: '満期まで',
        date2: '日',

        premium: 'プレミアム',
        return1: 'ROI',
        annualized1: '年率ROI',
        return2: 'ROI',
        annualized2: '年率ROI',
        probability: '確率',

        optionname: '銘柄名',
        volume: '出来高',
        price: '現在値',
        optiondlg: {
            buy: '購入 ',
            sell: '売却 ',
            title: '詳細',
            // “买入 100股 COIN” 的“股”
            shareSize: '',
            unit: '枚',
            dedaline: 'オプションの満期時',
            part1title: 'オプションの満期時',
            strikedIntervalReturn: '権利行使後ROI',
            strikedAnnualizedReturn: '権利行使後年率ROI',
            tip: '*上記のデータは情報提供を目的として作成されたものであり、特定の金融商品への投資や売買等を推奨するものではありません。投資に関する最終的な判断は、投資家ご自身の責任で行ってください。',
            btn: '今すぐエントリー'
        },
       verify: 'Verify as PI for details >',
        tenor1: 'Tenor(Y)',
        tenor2: 'Tenor(M)',
        tenor3: 'Tenor(D)',
        coupon: 'Coupon Rate',
        coupon_shark: 'Coupon',
        client_yield: 'Yield',
        coupon_flat: 'Coupon',
        strike: 'Strike',
        put_strike: 'Put Strike',
        participation_strike: 'Participation Strike',
        participation: 'Participation',
        ko_level: 'Ko Level',
        day: 'D',
        year: 'Y',
        month: 'M',
        wtchNum: 'Watch Count',
        piauth01: 'Complete PI Verification',
        piauth02: 'View Price Change and Fundraising Amount',
        toauthBtn: 'Verify Now',
        viewBtn: 'View more',
    }
};
